import { ThreadTask } from '@langchain/langgraph-sdk';

export function filterPendingInterurpts(tasks: ThreadTask[]) {
  return tasks
    .filter((task) => {
      // tasks returned no writes
      if (Array.isArray(task.result) && task.result.length === 0) {
        return true;
      }

      // is a pending task / errored task
      if (task.result == null) {
        return true;
      }

      // there's some funkiness with the possible values of task.result
      // so we're checking for a few different cases of emptiness here
      if (
        typeof task.result === 'object' &&
        task.result !== null &&
        Object.keys(task.result).length === 0
      ) {
        return true;
      }

      return false;
    })
    .flatMap((task) =>
      task.interrupts?.map((interrupt) => ({ interrupt, task }))
    );
}
